import type { FC } from 'react'
import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import DefineDetectValidateImage from './DefineDetectValidateImage'

const copy = {
  heading: `Define, detect, and validate data quality violations and enforce privacy controls.`,
}

const feature = [
  {
    head: `Trust`,
    description: `Automate and scale data quality best practices with Tracking Plans to power your tools with clean, reliable data. `,
  },
  {
    head: `Empower`,
    description: `Align your teams and tools with secure and consistent patient, member or clinician data.`,
  },
  {
    head: `Protect`,
    description: `Simplify compliance with automated data governance and real-time sensitive data, including PHI and PII, screening.`,
  },
]

const link = {
  text: `Explore Protocols`,
  url: `/product/protocols/`,
}

const DefineDetectValidate: FC = () => {
  const pageConfig = usePageConfig()
  return (
    <StyledSectionBase variant="2Col" reverse={true}>
      <SectionContents>
        <DefineDetectValidateImage alt={`Illustration: ${copy.heading}`} />
      </SectionContents>
      <StyledCopy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <ColumnTrackWrapper>
            <ColumnTrack gap="small">
              {feature.map((feature) => (
                <FeatureBoxBase key={feature.head} alignment="left">
                  <FeatureBox.Body>
                    <FeatureBox.Title>{feature.head}</FeatureBox.Title>
                    <FeatureBox.Text>{feature.description} </FeatureBox.Text>
                  </FeatureBox.Body>
                </FeatureBoxBase>
              ))}
            </ColumnTrack>
          </ColumnTrackWrapper>
          <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </StyledCopy>
    </StyledSectionBase>
  )
}

export default DefineDetectValidate

const SectionContents = styled(Section.Contents)`
  margin: auto 0;
`

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const StyledCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    justify-self: end;
    align-self: center;
  }
`

const ColumnTrackWrapper = styled.div`
  padding-top: 40px;
`
